/**
 * Filters duplicates out of an array, based on a combination of fields in each array item.
 * The first item with a given key is the one item kept in the subset that is returned: any
 * further items with that key are ignored.
 * @param {any[]} array an array to filter
 * @param {string[]} keys the fields with which to create a unique key
 * @return {any[]} the input array, minus any items having a duplicate key
 */
export const uniqueByKeys = (array: any[], keys: string[]) =>
  array.filter(
    (filteredSet => item =>
      (joinedPropertyValue => !filteredSet.has(joinedPropertyValue) && filteredSet.add(joinedPropertyValue))(
        keys.map(key => String(item[key]).toUpperCase()).join(''),
      ))(new Set()),
  );
